import React, { useState, useContext } from 'react';
import { Button, Form, Message, Segment } from 'semantic-ui-react';
import { Auth } from 'aws-amplify';
import { authContext } from '../containers/AuthProvider';
import { themeContext } from "../containers/ThemeProvider";

export default function ChangePassword({ onClose }) {
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { login } = useContext(authContext);
  const { assets } = useContext(themeContext);

  async function handleChangePassword(e) {
    e.preventDefault();
    setError('');
    setSuccess(false);
  
    try {
      const user = await Auth.signIn(email, oldPassword);
  
      await Auth.changePassword(user, oldPassword, newPassword);
  
      setSuccess(true);
      await login(email, newPassword);
  
    } catch (err) {
      setError(getFriendlyErrorMessage(err));
  
      try {
        await Auth.signOut();
      } catch (signOutError) {
        console.error('Error signing out after failed password change:', signOutError);
      }
    }
  }
  

  function getFriendlyErrorMessage(err) {
    const msg = err?.message || '';
  
    if (
      msg.includes('validation error detected')
    ) {
      return 'Password format is invalid. Make sure it does not start or end with spaces, has at least 8 characters, and includes at least one special character.';
    }
  
    return msg;
  }
  
  

  return (
    <Segment>
      <Form data-testid="change-password-form"  onSubmit={handleChangePassword}>
        <Form.Input
          fluid
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Form.Input
          fluid
          type="password"
          placeholder="Current Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          required
        />
        <Form.Input
          fluid
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />
        <Button data-testid="ChangePasswordButton" fluid style={{backgroundColor: assets?.headerColour}} type="submit">Change Password</Button>
      </Form>
      {success && <Message success content="Password changed successfully! Logging you in..." />}
      {error && <Message error content={error} />}
      <Button basic fluid onClick={onClose} style={{ marginTop: '1em' }}>Cancel</Button>
    </Segment>
  );
}
